import { parseStringifiedDuration } from '@modules/feed/utils/parseStringifiedDuration';
import { QUANTIFY_QUERY_RETENTION_KEY } from '@modules/quantify/hooks/useQuantifySessionStorage/constants';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { QuantifyState } from '@modules/quantify/store/types';
import { useCallback } from 'react';

export const useQuantifySessionStorage = () => {
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);
  const query = useQuantifyStore(({ query }) => query);
  const metadata = useQuantifyStore(({ metadata }) => metadata);

  const setSessionStorageFromQuantifyStore = useCallback(() => {
    sessionStorage.setItem(
      QUANTIFY_QUERY_RETENTION_KEY,
      JSON.stringify({
        query,
        metadata,
      }),
    );
  }, [metadata, query]);

  const setQuantifyStoreFromSessionStorage = useCallback(() => {
    const persistedState = sessionStorage.getItem(QUANTIFY_QUERY_RETENTION_KEY);

    if (persistedState) {
      try {
        const parsedPersistedState: Pick<QuantifyState, 'query' | 'metadata'> =
          JSON.parse(persistedState);

        if (parsedPersistedState.query.groupBy) {
          dispatch({
            type: QuantifyActionType.SET_QUERY,
            payload: {
              ...parsedPersistedState.query,
              duration: parseStringifiedDuration(
                parsedPersistedState.query.duration,
              ),
              compareTo:
                parsedPersistedState.query.compareTo?.type === 'timerange'
                  ? {
                      type: 'timerange',
                      duration: parseStringifiedDuration(
                        parsedPersistedState.query.compareTo.duration,
                      ),
                    }
                  : parsedPersistedState.query.compareTo,
            },
          });
          dispatch({
            type: QuantifyActionType.SET_METADATA,
            payload: parsedPersistedState.metadata,
          });
        }
      } catch {
        sessionStorage.removeItem(QUANTIFY_QUERY_RETENTION_KEY);
      }
    }
  }, [dispatch]);

  return {
    setSessionStorageFromQuantifyStore,
    setQuantifyStoreFromSessionStorage,
  };
};
